import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { initSentry, Sentry } from "./lib/sentry";
import { supabase } from "@/integrations/supabase/client";
import { installFunctionsBootRetry } from "./lib/functionsBootRetry";

initSentry();
// Retry server functions that fail to start (503 BOOT_ERROR) before callers see an error.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
installFunctionsBootRetry(supabase.functions as any);

// App entry point
createRoot(document.getElementById("root")!).render(
  <Sentry.ErrorBoundary
    fallback={
      <div style={{ padding: 24, fontFamily: "system-ui" }}>
        <h1>Something went wrong.</h1>
        <p>The error has been reported. Please reload the page.</p>
      </div>
    }
  >
    <App />
  </Sentry.ErrorBoundary>,
);
